'use strict';

window.LoaderFactory = (function(w, d, $, undefined) {

	return function(options, Lib) {

		let settings  = $.extend({
			rootClass: '',
			readyEvent: 'zp-ready',
			loadEvent: 'zp-load',
			unloadEvent: 'zp-unload',
			initType: ''
		}, options);

		let loaded = false;
		let instances = [];

		if(settings.initType == 0 || settings.initType == '') {
			$(d).on(settings.readyEvent, () => init());
		}
		if(settings.initType == 1) {
			$(d).on(settings.loadEvent, () => load());
		}

		function init() {
			build();
		}

		function load() {
			build();
		}

		function build() {
			let instanceDivs = $('.' + settings.rootClass).not('.zp_loaded');
			instanceDivs.each((index, element) => {
				let root = $(element);
				root.addClass('zp_loaded');
				let instance = new Lib(root);
				instances.push(instance);
			});

			if(!loaded) {
				$(document).on(settings.unloadEvent, unload);
				loaded = true;
			}
		}

		function unload() {
			$.each(instances, (index, instance) => {
				instance.unload();
			});
			instances = [];
		}
	};
}(window,document,jQuery));